export * from './app-footer.component';



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/components/app-footer/index.ts